/**
 * @typedef {import('./schema').UserProperties} UserProperties
 * @typedef {import('./schema').Event} Event
 */

/**
 * @typedef {Object} RBGtmblientArgs
 * @property {UserProperties} userProperties
 */

/**
 * RB Google Tag Manager (GTM) Client for tracking events.
 */
class RbGtmClient {
  /**
   * @constructor
   * @param {RBGtmblientArgs} args
   */
  constructor(args) {
    /**
     * The user properties.
     * @type {UserProperties}
     * @private
     */
    this._userProperties = args.userProperties;
  }

  /**
   * @returns {UserProperties}
   */
  get userProperties() {
    return this._userProperties;
  }

  /**
   * Extend the user properties with new values.
   * When GTM client is initialised a set of default user properties get
   * pushed to the datalayer. They can be extended based on requirements on
   * individual pages.
   * @param {Partial<UserProperties>} newUserProperties
   */
  extendUserProperties(newUserProperties) {
    this._userProperties = { ...this._userProperties, ...newUserProperties };
  }

  /**
   * @param {Event} payload
   */
  static track(payload) {
    if (Object.keys(payload).includes("ecommerce")) {
      (() => window.dataLayer && window.dataLayer.push({ ecommerce: null }))();
    }
    (() => window.dataLayer && window.dataLayer.push(payload))();
  }
}
export { RbGtmClient };
